import React, { useState, useEffect, useRef } from 'react';

const AnimatedCounter = ({ 
  endValue, 
  duration = 2000, 
  prefix = '', 
  suffix = '', 
  className = '' 
}) => {
  const [currentValue, setCurrentValue] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          animateCounter();
          setHasAnimated(true);
        }
      },
      { threshold: 0.5 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCounter = () => {
    const startTime = Date.now();
    const startValue = 0;
    
    // Extract numeric value from endValue if it's a string like "95%" or "50+"
    const numericEnd = parseInt(endValue.toString().replace(/[^\d]/g, '')) || 0;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const current = Math.floor(startValue + (numericEnd - startValue) * easeOutQuart);
      
      setCurrentValue(current);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  };

  const displayValue = () => {
    if (endValue.toString().includes('%')) {
      return `${currentValue}%`;
    } else if (endValue.toString().includes('+')) {
      return `${currentValue}+`;
    }
    return `${prefix}${currentValue}${suffix}`;
  };

  return (
    <div ref={elementRef} className={className}>
      {displayValue()}
    </div>
  );
};

export default AnimatedCounter;